// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export { ImporterDashboard } from './ImporterDashboard.tsx';

export const ImporterDashboardLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ImporterDashboardContainer" */ './ImporterDashboard.tsx'
			)
		).ImporterDashboard,
});
